// this.$i18n.locale === 'zh-cn' ?
// $t('data.dataManagement')
export default {
  main: {
    change_identity: '切换身份'
  },
  status: {
    normal: '正常',
    abnormal: '异常',
    awaiting_assessment: '待评估',
    evaluated: '已评估',
    unknown: '未知',
    low_risk: '低风险',
    medium_risk: '中风险',
    high_risk: '高风险',
    approved: '审核通过',
    approval_failed: '审核未通过',
    fetal_type: 'Fetal type',
    have: '有',
    none: '无',
    qcRemark: '请输入质控备注',
    qcTitle: '报告审核',
    qcBtn: '提交审核'
  },
  normal: {
    no: '序号',
    add: '新增',
    incomplete: '录入信息不完整，请将必填信息填写完整',
    submit: '提交',
    submitting: '提交中...',
    loading: '加载中...',
    upload_pic: '请上传图片',
    not_empty: '不能为空',
    upload: '点击上传',
    upload_succeeded: '上传成功，请及时补充信息',
    upload_failed: '上传失败',
    sure_give_up: '确定放弃编辑？',
    edit: '编辑',
    operation_succeeded: '操作成功',
    base_info: '基础信息'
  },
  rule: {
    not_empty: '不能为空',
    only_char_num_chinese: '只能输入数字、字母和中文'
  },
  search: {
    search: '检索',
    search2: '查询',
    reset: '重置',
    show: '预览',
    pregnant_women_search: '孕妇检索',
    pregnancy_women_search: '孕妇孕检信息检索',
    hospital: '医院',
    hospital_placeholder: '请选择医院',
    full_name: '姓名',
    enter_name: '请输入姓名',
    id_card: '身份证',
    enter_id_card: '请输入身份证号',
    clinic_number: '病历号',
    enter_clinic_number: '请输入病历号',
    phone_number: '手机号',
    enter_phone: '请输入手机号',
    pregnancy: '孕期',
    pregnancy_placeholder: '请选择孕期类型',
    entry_time: '录入时间',
    age: '年龄',
    pregnancy_num: '孕次',
    gestational_week: '孕周',
    week: '周',
    day: '天',
    operation: '操作',
    select_delete: '请选择需要删除的记录',
    make_sure: '确定删除所选中的记录',
    click_ok: '当您点击确定按钮后，这些记录将会被彻底删除',
    delete_success: '删除成功',
    assessment: '评估',
    details: '详情',
    calculation: '计算',
    delete: '删除',
    import: '导入',
    export: '导出',
    export_all: '导出全部',
    export_lucina: '单机导出',
    queryCriteria: '查询条件',
    define: '确定',
    cancel: '取消',
    examine: '审核',
    print: '打印',
    print_preview: '打印预览',
    update_time: '更新时间',
    calibration: '校准',
    createTime: '创建时间',
    import_data: '导入数据',
    import_succeeded: '导入成功',
    import_failure_records: '导入失败记录',
    error_line: '错误行',
    error_message: '错误信息',
    export_succeeded: '导出成功'
  },
  login: {
    login: '登录',
    account: '账号',
    enter_account: '请输入账号',
    password: '密码',
    enter_password: '请输入密码',
    forgot_password: '忘记密码',
    remember_password: '记住密码',
    anonymous_login: '匿名登录',
    contact_us: '请联系管理员以获取新密码',
    contact_tel: '管理员联系方式',
    failed_exit: '退出系统失败',
    modify_avatar: '更换'
  },
  home: {
    personal_center: '个人中心',
    password_modification: '密码修改',
    old_password: '旧密码',
    new_password: '新密码',
    confirm_password: '确认密码',
    new_password_rule: '至少8位密码，区分大小写',
    new_password_rule1: '请至少输入 8 个字符，包含大写字母，小写字母，数字和特殊字符中的三种及以上。',
    log_out: '退出登录',
    today_num: '当日孕妇',
    week_num: '本周孕妇',
    month_num: '本月孕妇',
    assessment_completed: '已完成评估',
    report_printed: '报告已打印',
    incomplete_assessment: '未完成评估',
    report_not_printed: '报告未打印',
    positive_rate: '阳性率统计',
    gestational_week_distribution: '分娩孕周分布统计',
    pregnant_women_age_distribution: '年龄分布统计',
    eclampsia_risk_rate: '子痫前期风险因素统计',
    sga_risk_rate: '小于胎龄儿风险因素统计',
    downs_risk_rate: '唐氏综合征风险因素统计',
    fgr_Risk_rate: '胎儿生长受限风险因素统计',
    dvt_risk_rate: '静脉血栓风险因素统计',
    plgf_point: 'PLGF中位数变化趋势',
    utpi_point: 'UTPI中位数变化趋势',
    sflt_point: 'sFlt-1中位数变化趋势',
    papp_point: 'PAPP-A中位数变化趋势',
    median_change_trend: '中位数变化趋势',
    distribution_point: '分布点',
    patient: '患者'
  },
  databoard: {
    maintitle: '智慧妇幼数据平台',
    title1: '已录入孕妇数量排行榜',
    title2: '孕妇年龄、疾病分布占比',
    title3: '孕妇年龄分布占比',
    title4: '孕妇主要疾病分布占比',
    title5: '妊娠结局类型统计',
    title6: '预测阳性率',
    hospital_info: '当前医院信息',
    hospital_address: '医院地址',
    hospital_level: '医院等级',
    hospital_phone: '医院电话',
    estimate_num: '完成评估数量',
    gravida_num: '已录入孕妇数',
    delivery_num: '完成分娩数量',
    people: '位',
    title7: '风险评估项目人数分布',
    title8: '孕妇结局',
    hospital_num: '医院数量',
    gravida_num2: '孕妇数量',
    maternity_num: '产妇数量'
  },
  infoEntry: {
    personal_information: '个人信息',
    past_medical_history: '既往病史',
    obstetric_history: '产科史',
    full_name: '姓名',
    enter_name: '请输入姓名',
    phone_number: '手机号',
    enter_phone: '请输入手机号',
    clinic_number: '病历号',
    enter_clinic_number: '请输入病历号',
    gender: '性别',
    id_card: '身份证',
    enter_id_card: '请输入身份证号',
    check_id_card: '身份证不合法',
    date_of_birth: '出生日期',
    choose_birth_day: '请选择出生日期',
    age: '年龄',
    age_placeholder: '请输入年龄',
    years: '岁',
    height: '身高',
    enter_height: '请输入身高',
    weight_before_pregnancy: '孕前体重',
    enter_weight: '请输入孕前体重',
    pre_pregnancy_BMI: '孕前BMI',
    pre_pregnancy_BMI_placeholder: '请输入孕前BMI',
    race: '种族',
    nation: '民族',
    menstrual_cycle: '月经周期',
    enter_menstrual_cycle: '请输入月经周期',
    week: '周',
    day: '天',
    last_menstruation: '末次月经',
    choose_last_menstruation: '请选择末次月经日期',
    mode_of_pregnancy: '怀孕方式',
    choose_mode_of_pregnancy: '请选择怀孕方式',
    number_of_getuses: '胎儿数量',
    choose_number_of_getuses: '请选择胎儿数量',
    consanguineous_marriage: '近亲婚配',
    consanguineous_marriage_placeholder: '请选择近亲婚配',
    group: '分组信息',
    smoking_history: '吸烟史',
    smoking_history_placeholder: '请选择吸烟史',
    drinking_history: '饮酒史',
    drinking_history_placeholder: '请选择饮酒史',
    incomplete: '录入信息不完整，请将必填信息填写完整',
    already_exists: '记录已存在',
    overwrite: '记录已存在，是否覆盖原纪录',
    no: '否',
    yes: '是',
    preservation: '保存',
    clear: '清空',
    previous_page: '上一页',
    next_page: '下一页',
    chronic_hypertension: '慢性高血压史',
    chronic_hypertension_placeholder: '请选择慢性高血压史',
    diabetes: '糖尿病',
    diabetes_placeholder: '请选择糖尿病类型',
    treatment: '治疗方式',
    treatment_placeholder: '请选择糖尿病治疗方式',
    sle: '系统性红斑狼疮',
    sle_placeholder: '请选择系统性红斑狼疮',
    aps: '抗磷脂综合征',
    aps_placeholder: '请选择抗磷脂综合征',
    other_diseases: '其它免疫病',
    other_diseases_placeholder: '请输入其它免疫病',
    eclampsia: '子痫前期家族史',
    eclampsia_placeholder: '请选择子痫前期家族史',
    kidney_disease: '慢性肾病史',
    kidney_disease_placeholder: '请选择慢性肾病史',
    liver_disease: '肝病史',
    liver_disease_placeholder: '请选择肝病史',
    downs: '唐氏儿生育家族史',
    downs_placeholder: '请选择唐氏儿生育家族史',
    vte_famliy: 'VTE家族史',
    vte_famliy_placeholder: '请选择VTE家族史',
    vte: 'VTE病史',
    vte_placeholder: '请选择VTE病史',
    varicose_veins: '下肢静脉曲张',
    varicose_veins_placeholder: '请选择下肢静脉曲张',
    medical_vomplications: '内科并发症',
    medical_vomplications_placeholder: '请选择内科并发症',
    thrombophilia: '易栓症',
    thrombophilia_placeholder: '请选择易栓症',
    vte_after_major: '大手术后VTE病史',
    vte_after_major_placeholder: '请选择大手术后VTE病史',
    primipara: '初产妇',
    primipara_title: '(初产妇: 无怀孕超过24周经历)',
    primipara_placeholder: '请选择是否为初产妇',
    pregnancies_num: '怀孕次数',
    pregnancies_num_placeholder: '请输入怀孕次数',
    deliveries_num: '分娩次数',
    deliveries_num_placeholder: '请选择分娩次数',
    last_delivery_Time: '前次分娩时间',
    last_delivery_Time_placeholder: '请选择前次分娩时间',
    gestational_weeks_of_previous_delivery: '前次分娩孕周',
    previous_newborn_weight: '低体重儿',
    previous_newborn_weight_placeholder: '请输入新生儿体重',
    before_delivery_Time: '历史分娩时间',
    before_delivery_Time_placeholder: '请选择历史分娩时间',
    gestational_weeks_of_before_delivery: '历史分娩孕周',
    history_of_adverse_pregnancy: '不良妊娠史',
    name_not_empty: '姓名不得为空',
    phone_not_empty: '手机号不得为空',
    phone_11: '手机号长度为11位',
    idCard_not_empty: '身份证/病历号不得为空',
    birth_not_empty: '出生日期不得为空',
    age_not_empty: '年龄不得为空',
    height_not_empty: '身高不得为空',
    height_no_less_than_80: '身高不得小于80cm',
    height_no_more_than_250: '身高不大于250cm',
    weight_not_empty: '体重不得为空',
    weight_no_less_than_25: '体重不得小于25kg',
    weight_no_more_than_250: '体重不得大于250kg',
    race_not_empty: '种族不得为空',
    nation_not_empty: '民族不得为空',
    menstrualCycle_not_empty: '月经周期不得为空',
    menstrualCycle__no_less_than_10: '月经周期不得少于10',
    lastMenstruation_not_empty: '末次月经不得为空',
    pregnancyMode_not_empty: '怀孕方式不得为空',
    babyNum_not_empty: '胎儿数量不得为空',
    isCloseMarriage_not_empty: '近期婚配不得为空',
    isSmoke_not_empty: '吸烟史不得为空',
    isDrink_not_empty: '饮酒史不得为空',
    save_success: '保存成功',
    normal_range: '正常范围',
    sp_no_less_than_30: '',
    sp_no_more_than_240: '',
    dp_no_less_than_20: '',
    dp_no_more_than_180: ''
    // sp_no_less_than_30: '收缩压不得小于90mmHg',
    // sp_no_more_than_240: '收缩压不得大于140mmHg',
    // dp_no_less_than_20: '舒张压不得小于60mmHg',
    // dp_no_more_than_180: '舒张压不得大于90mmHg'
  },
  pregnancy: {
    basic_information_of_pregnancy_test: '孕检基础信息',
    edit_basic_information_of_pregnancy_test: '孕检基础信息编辑',
    ultrasonic_information: '超声信息',
    edit_ultrasonic_information: '超声信息编辑',
    biochemical_markers: '生化标志物',
    edit_biochemical_markers: '生化标志物信息编辑',
    new_disease: '新发症',
    edit_new_disease: '新发症信息编辑',
    medication_history: '服药史',
    edit_medication_history: '服药史信息编辑',
    pregnancy_test_information: '孕检信息',
    gestational_week: '孕周',
    essential_information: '基本信息',
    name_of_pregnant_woman: '孕妇姓名',
    please_enter_the_name_of_the_pregnant_woman: '请输入孕妇姓名',
    evaluation_items: '评估项目',
    clinic_no: '门诊号',
    clinic_no_placeholder: '请输入门诊号',
    gestational_age_calculation: '孕周计算',
    gestational_age_calculation_placeholder: '请选择孕周计算方式',
    left_arm_first_time: '左臂第一次',
    sp_dp: '(收/舒)',
    systolic_pressure: '收缩压',
    diastolic_pressure: '舒张压',
    pregnancy: '孕期',
    pregnancy_placeholder: '请选择孕期类型',
    inspection_date: '检查日期',
    inspection_date_placeholder: '请选择检查日期',
    right_arm_first_time: '右臂第一次',
    sending_hospital: '送检医院',
    sending_hospital_placeholder: '请输入送检医院',
    left_arm_second_time: '左臂第二次',
    weight: '体重',
    weight_placeholder: '请输入体重',
    sending_doctor: '送检医生',
    sending_doctor_placeholder: '请输入送检医生',
    right_arm_second_time: '右臂第二次',
    height: '身高',
    inspection_department: '送检科室',
    inspection_department_placeholder: '请选择送检科室',
    mean_arterial_pressure: '平均动脉压',
    date_of_submission_for_inspection: '送检日期',
    date_of_submission_for_inspection_placeholder: '请选择送检日期',
    message_1: '请检索并选择孕妇孕次',
    pregnancy_type: '孕期类型',

    left: '左',
    right: '右',
    average: '平均',
    utpi_no_less_than: 'UTPI值不得小于0',
    utpi_no_more_than: 'UTPI值不得大于10',
    crl: '头臀长',
    crl_no_empty: '头臀长值不得为空',
    crl_no_less_than: '头臀长值不得小于25',
    crl_no_more_than: '头臀长值不得大于110',
    crown_rump_length_placeholder: 'CRL孕周',
    head_circumference: '头围',
    bpd: '双顶径',
    bpd_no_empty: '双顶径值不得为空',
    bpd_no_less_than: '双顶径值不得小于10',
    bpd_no_more_than: '双顶径值不得大于120',
    abdominal_circumference: '腹围',
    nuchal_translucency: '颈项透明层',
    nt_mom: 'NT MoM值',
    nt_weel: 'NT 孕周',
    value: '值',
    femur_length: '股骨长',
    test_date: '检测日期',
    test_date_placeholder: '请选择检测日期',
    test_no: '检测编号',
    test_no_placeholder: '请输入检测编号',
    fetal_weight: '胎儿体重',
    message_2: '请先提交孕妇孕检信息',

    marker_type: '标志物类型',
    marker_type_placeholder: '请选择标志物类型',
    instrument_type: '仪器类型',
    instrument_type_placeholder: '请选择仪器类型',
    sample_no: '样本编号',
    sample_no_placeholder: '请输入样本编号',
    sample_type: '样本类型',
    sample_type_placeholder: '请选择样本类型',
    sample_characteristics: '样本性状',
    sample_characteristics_placeholder: '请选择样本性状',
    sampling_date: '采样日期',
    sampling_date_placeholder: '请选择采样日期',
    concentration_value: '检测值',
    concentration_value_placeholder: '请输入数值',
    operation_time: '操作时间',

    name_of_new_disease: '新发症名称',
    click_select: '点击选择',
    dagnostic_gestational_age: '诊断孕周',
    date_of_diagnosis: '诊断日期',
    date_of_diagnosis_placeholder: '点击选择日期',
    hospitalization: '住院治疗',
    hospitalization_placeholder: '请选择是否住院治疗',
    disease_reversion: '疾病归转',
    disease_reversion_placeholder: '请输入疾病归转',
    remark: '备注项',
    remark_placeholder: '请输入备注信息',

    drug_name: '药物名称',
    drug_name_placeholder: '请输入药物名称',
    specification: '规格',
    specification_placeholder: '请输入规格',
    total_daily_dose: '每日总剂量',
    total_daily_dose_placeholder: '请输入每日总剂量',
    take_way: '服用方法',
    take_way_placeholder: '请输入服用方法',
    take_day: '服用天数',
    take_day_placeholder: '请输入服用天数',
    take_gestational_weeks: '服用孕周',
    take_gestational_weeks_placeholder: '请输入服用孕周',
    medication_ADHERENCE: '药物依从性',
    medication_ADHERENCE_placeholder: '请输入药物依从性'
  },
  outcome: {
    pregnancy_outcome: '妊娠结局',
    delivery_information: '分娩信息',
    terminal_pregnancy: '终止妊娠',
    terminal_pregnancy_placeholder: '请选择是否终止妊娠',
    termination_of_pregnancy: '终止妊娠孕周',
    termination_reason: '终止妊娠原因',
    termination_reason_placeholder: '请输入终止妊娠原因',
    delivery_mode: '分娩方式',
    delivery_mode_placeholder: '请选择分娩方式',
    gestational_week_of_delivery: '分娩孕周',
    drug_use_during_pregnancy: '孕期用药情况',
    drug_use_during_pregnancy_placeholder: '请选择孕期用药情况',
    therapeutic_drugs: '治疗药物',
    therapeutic_drugs_placeholder: '请输入治疗药物',
    compliance_evaluation: '依从性评价',
    compliance_evaluation_placeholder: '请选择依从性评价',
    newborn_weight: '新生儿体重',
    newborn_weight_placeholder: '请输入新生儿体重',
    newborn_height: '新生儿身高',
    newborn_height_placeholder: '请输入新生儿身高',
    pregnancy_woman_outcome: '孕妇结局',
    edit_pregnancy_woman_outcome: '孕妇结局编辑',
    disease_name: '疾病名称',
    disease_name_placeholder: '请选择疾病名称',
    diagnosis_time: '诊断时间',
    diagnosis_time_placeholder: '请选择诊断时间',
    remark: '备注',
    neonatal_outcome: '新生儿结局',
    edit_neonatal_outcome: '新生儿结局编辑'
  },
  follow: {
    postpartum_follow_up: '产后随访',
    edit_postpartum_follow_up: '产后随访编辑',
    temperature: '体温',
    temperature_placeholder: '请输入体温',
    temperature_not_empty: '体温不得为空',
    temperature_no_less_than_0: '体温不得小于0℃',
    temperature_no_more_than_60: '体温不得大于60℃'
  },
  risk: {
    risk_factors: '既往病史、产科史风险因素',
    new_onset_risk_factors: '新发症风险因素',
    risk_assessment_result: '风险评估结果',
    guidance: '指导建议',
    preeclampsia: '子痫前期',
    downs: '唐氏综合征',
    sga: '小于胎龄儿',
    fgr: '胎儿生长受限',
    benous_thrombosis: '静脉血栓',
    plgf_value: 'PLGF参考值',
    plgf_result: 'PLGF评估结果',
    sft_value: 'PLGF/sFlt-1参考值',
    sflt_result: 'PLGF/sFlt-1结果',
    early_onset_PE: '',
    premature_PE: '早产型PE',
    basic_risk_assessment: '基础风险',
    final_risk_assessment: '综合风险',
    basic_risk_assessment_value: '基础风险值',
    final_risk_assessment_value: '综合风险值',
    evaluation_result: '评估结果',
    prenatal_factors: '产期因素',
    postnatal_factors: '产后因素',
    temporary_factor: '临时因素',
    evaluation_score: '评估分值',
    estimate_error: '评估异常',
    no_evaluation_information: '暂无评估信息'
  },
  data: {
    dataManagement: '数据管理',
    evaluation_items: '评估项目',
    evaluation_items_placeholder: '请选择评估项目',
    pregnancy_test_date: '孕检日期',
    risk_assessment: '风险评估',
    risk_assessment_placeholder: '是否风险评估',
    evaluation_status: '评估状态',
    evaluation_status_placeholder: '请选择评估状态',
    evaluation_results: '评估结果',
    evaluation_results_placeholder: '请选择评估结果',
    data_status: '数据状态',
    data_status_placeholder: '请选择数据状态',
    group_type_placeholder: '请选择分组信息',
    evaluation_date: '评估日期'
  },
  qc: {
    qcReview: '质控审核',
    qcObject: '质控对象',
    qcQuery: '质控查询',
    detection_time: '采样时间',
    gestational_age_range: '孕周范围',
    ethnic_type: '民族',
    ethnic_type_placeholder: '请选择民族',
    race_type: '种族',
    race_type_placeholder: '请选择种族',
    qcResults: '质控结果',
    qcResults_placeholder: '请选择质控结果',
    xbMap: 'X-B质控图',
    advanced_options: '高级选项',
    generate_results: '生成质控结果',
    define: '确定',
    pass: '通过',
    fail: '不通过',
    audit_date: '审核日期',
    mom_value: '综合平均MoM值',
    examination_result: '审核结果建议',
    condition: '是否通过审核',
    good: '良好质量报告示例',
    bad: '不良质量报告示例',
    ewma_chart: 'EWMA质控图',
    marker_type: '标志物类型',
    mom_value2: '平均MoM值',
    audit_result: '审核结果'
  },
  report: {
    report_management: '报告管理',
    evaluation_date: '评估日期',
    evaluation_type: '评估类型',
    evaluation_type_placeholder: '请选择评估类型',
    evaluation_status: '评估状态',
    evaluation_status_placeholder: '请选择评估状态',
    evaluation_results: '评估结果',
    evaluation_results_placeholder: '请选择评估结果',
    print_status: '打印状态',
    print_status_placeholder: '请选择打印状态',
    audit_status: '审核状态',
    audit_status_placeholder: '请选择审核状态',
    test_items: '检测项目',
    english_abbreviation: '英文简称',
    sampling_gestational_week: '采样孕周',
    result: '结果',
    unit: '单位',
    mom_value: 'MoM值',
    early_onset: '早发型',
    premature: '早产型',
    full_term: '足月型',
    report_printing: '报告打印'
  },
  sys: {
    parameter_management: '常规参数管理',
    home_setting: '首页显示设置',
    risk_setting: '风险评估项目设置',
    pregnancy_setting: '系统孕期设置',
    ultrasound_setting: 'B超孕周计算设置',
    qc_setting: '质控计算设置',
    positive_rate: '阳性检出率',
    downs: '唐氏综合征',
    delivery_week_dis: '分娩孕周分布',
    trend: '中位数曲线',
    utpi_trend: 'UTPI趋势',
    vte: '静脉血栓',
    sga: '小于胎龄儿',
    pregnant_age_dis: '孕妇年龄分布',
    sflt_trend: 'sFlt-1趋势',
    preeclampsia: '子痫前期',
    fgr: '胎儿生长受限',
    plgf_trend: 'PLGF趋势',
    pappa_trend: 'PAPP-A趋势',
    tang_screen: '唐氏综合征',
    fgr2: '生长受限',
    first_trimester: '孕早期孕周',
    second_trimester: '孕中期孕周',
    third_trimester: '孕晚期孕周',
    trimester_start: '开始',
    trimester_end: '结束',
    pregnancy_time: '怀孕总时长',
    crl: 'CRL测量值上下限',
    bpd: 'BPD测量值上下限',
    value_up_placeholder: '请输入测量值上限',
    value_down_placeholder: '请输入测量值下限',

    aerfa: '计算参数α',
    beita: '计算参数β',
    aerfa_placeholder: '请输入计算参数α',
    beita_placeholder: '请输入计算参数β',
    xb_upper: 'X-B质控图上限',
    xb_upper_placeholder: 'X-B质控图上限',
    ewma_upper: 'EWMA质控图上限',
    ewma_upper_placeholder: 'EWMA质控图上限',

    hospital_management: '医院管理',
    hospital_alg_management: '医院算法管理',
    alg_edit: '编辑算法',
    now_hospital: '当前医院',
    search_placeholder: '请选择查询的医院',
    hospital_name: '医院名称',
    address: '地址',
    hospital_grade: '医院等级',
    superior_hospital: '上级医院',
    contacts: '联系人',
    contact_number: '联系电话',

    add_hospital: '新增医院',
    edit_hospital: '编辑医院',
    country: '所在国家',
    country_placeholder: '请选择所在国家',
    province: '所在省份（州）',
    province_placeholder: '请选择所在省份',
    city: '所在城市',
    city_placeholder: '请选择所在城市',
    area: '所在区（县级市）',
    area_placeholder: '请选择所在区',
    name: '医院/机构名称',
    name_placeholder: '请输入医院或者机构名称',
    level: '医院/机构等级',
    level_placeholder: '请选择医院或者机构等级',
    up_hospital: '上级医院/机构',
    up_hospital_placeholder: '请选择上级医院或者机构',
    address2: '医院/机构地址',
    address2_placeholder: '请输入医院或者机构地址',
    region: '所在大区',
    region_placeholder: '请选择所在大区',
    contacts_placeholder: '请输入医院或者机构联系人',
    contact_number_placeholder: '请输入联系人电话',
    logo: '图案',
    logo_placeholder: '尺寸：800px * 800px | 大小：不限，根据实际自行确定大小 | 格式：jpg，gif，png，jpeg',
    electronic_seal: '电子章上传',
    electronic_seal1: '电子章1',
    electronic_seal2: '电子章2',
    electronic_seal3: '电子章3',
    longitude: '经度坐标值',
    latitude: '纬度坐标值',

    template_management: '模板管理'
  },
  user: {
    user_management: '用户管理',
    user_placeholder: '请输入用户名',
    username: '用户名',
    username_placeholder: '请输入用户名',
    permission: '用户权限',
    permission_placeholder: '请选择该用户权限',
    hospital: '医院/机构',
    avatar: '头像',
    avatar_placeholder: '上传头像',
    password: '登录密码',
    password_placeholder: '请设置登录密码',
    phone: '手机号',
    phone_placeholder: '请输入用户手机号',
    electronic_signature: '电子签名',
    electronic_signature_placeholder: '此处为签名照',
    hospital_placeholder: '请选择医院或机构',
    add_user: '新增用户',
    edit_user: '编辑用户',
    confirm_modification: '确认修改',
    reset_password: '重置密码'
  },
  temp: {
    edit_temp: '模板编辑'
  },
  algorithm: {
    algorithm_detail: '算法详情',
    preeclampsia: '子痫前期',
    tang_screen: '唐氏综合征',
    sga: '小于胎龄儿',
    fgr: '胎儿生长受限',
    last_modified_date: '上次修改日期',
    algorithm_evaluation_range: '算法评估允许的孕周范围',
    first_trimester_range: '孕早期孕周范围',
    second_trimester_range: '孕中期孕周范围',
    third_trimester_range: '孕晚期孕周范围',
    trimester_range_placeholder: '开始孕周',
    trimester_range_placeholder2: '结束孕周',
    screening_method: '筛查方式',
    first_trimester: '孕早期',
    first_trimester_placeholder: '单孕期',
    second_trimester: '孕中期',
    second_trimester_placeholder: '请选择孕中期筛查方式',
    third_trimester: '孕晚期',
    third_trimester_placeholder: '请选择孕晚期筛查方式',

    model_cutoff_value_setting: '算法模型Cutoff值设置',
    model_critical_cutoff_value_setting: '算法模型临界风险值设置',
    critical: '临界',
    first_trimester_early: '孕早期早发型',
    second_trimester_early: '孕中期早发型',
    third_trimester_early: '孕晚期早发型',
    first_trimester_preterm: '孕早期早产型',
    second_trimester_preterm: '孕中期早产型',
    third_trimester_preterm: '孕晚期早产型',
    first_trimester_term: '孕早期足月型',
    second_trimester_term: '孕中期足月型',
    third_trimester_term: '孕晚期足月型',
    gestational_week_range: '算法评估允许的孕周范围',

    detection_value_setting: '检测量Cutoff值设置',
    placeholder1: '12-15周>32pg/mL',
    placeholder2: '16-20周>60pg/mL',
    placeholder3: '20周以上>100pg/mL',
    placeholder4: '20-33周+6<38',
    placeholder5: '33周以上<38',

    algorithm_evaluation_model: '算法评估模型',
    model_placeholder1: '请选择孕早期评估模型',
    model_placeholder2: '请选择孕中期评估模型',
    model_placeholder3: '请选择孕晚期评估模型',

    plgf_coefficient: 'PLGF系数',
    week_coefficient: '周系数',

    risk_judgment_criteria: '风险判定准则',
    risk_judgment_criteria_placeholder: '请选择风险判定准则',

    median_calibration: '标志物中位数校准',
    marker_type: '标志物类型',
    marker_type_placeholder: '请选择标志物类型',
    pregnancy_type: '孕期类型',
    pregnancy_type_placeholder: '请选择孕期类型',
    ga_calib_model: '孕周定标模型',
    weight_calib_model: '体重定标模型',
    choose_model: '请选择校准模型',

    journal: '日志'
  },
  log: {
    journal: '日志',
    operation_type: '操作类型',
    operation_type_placeholder: '请选择操作类型',
    operation_content: '操作内容',
    operation_content_placeholder: '请选择操作内容',
    operation_user: '操作员',
    operation_user_placeholder: '请输入操作员名称搜索',
    operation_time: '操作时间'
  },
  hospitalLevel: {
    hospital_level_management: '医院/机构等级管理',
    hospital_level_management_placeholder: '请输入医院/机构等级',
    hospital_level_add: '新增医院/机构等级',
    title: '标题',
    title_placeholder: '请输入标题',
    priority: '优先级',
    priority_placeholder: '请输入优先级',
    hospital_level_edit: '修改医院/机构等级信息'
  },
  help: {
    help: '帮助',
    common_problem: '常见问题',
    full_pregnancy_management_plan: '全孕期管理方案',
    common_chart: '常规操作流程',
    person_chart: '个体操作流程图',
    batch_chart: '批量操作流程图',
    technical_support: '技术支持',
    ver_record: '版本维护记录',
    downs: '唐氏综合征',
    vte: '静脉血栓',
    sga: '小于胎龄儿',
    preeclampsia: '子痫前期',
    fgr: '胎儿生长受限',
    data_entry: '数据录入',
    fast_data_positioning: '数据快速定位',
    risk_assessment: '风险评估',
    report_management: '报告管理'
  },
  about: {
    about: '关于',
    team_profile: '团队简介',
    project_intro: '项目简介',
    preeclampsia: '子痫前期项目简介',
    tang_screen: '唐筛项目简介',
    sga: '小于胎龄儿项目简介',
    fgr: '胎儿生长受限项目简介',
    vte: '静脉血栓项目简介',
    system_info: '系统信息',
    precautions: '怀孕期间注意事项'
  },
  ovarianReserve: {
    enter: '请输入',
    AMH: '抗缪勒管激素',
    bFSH: '基础FSH',
    AFC: '窦卵泡计数',
    MenarcheAge: '初潮年龄',
    count: '个'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/zh-cn.js